module.exports = __webpack_public_path__ + "static/media/moon-white.f9f0c3c6.svg";